// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2QHSw","question":"Question_question__6Ng1I","description":"Question_description__1HN_-"};